import { format, parse, isValid } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import * as Icons from "lucide-react";
import { useState } from "react";

// value / onChange use ISO strings "yyyy-MM-dd". Affichage en français.
export function DatePicker({ value, onChange, testId, placeholder = "Choisir une date", disabled, className }) {
  const [open, setOpen] = useState(false);
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const valid = date && isValid(date);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testId}
          className={cn("w-full justify-start text-left font-normal", !valid && "text-muted-foreground", className)}>
          <Icons.CalendarDays className="mr-2 h-4 w-4 shrink-0" />
          {valid ? format(date, "d MMMM yyyy", { locale: fr }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={valid ? date : undefined} defaultMonth={valid ? date : new Date()}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
